module.exports = __webpack_public_path__ + "img/mock_sol.aacb2cfa.jpg";